/**
 * Surface-2 Truth Hardening — Payments (Feb 2026)
 * =================================================
 *
 * Single source of truth for the word "Paid":
 *
 *     paid_at != null  →  Paid (authority-confirmed)
 *     paid_at == null  →  NOT paid (pre-settlement)
 *
 * Authoritative payment truth MUST come from Stripe webhook /
 * payment-event confirmation OR an operator-authorised manual
 * mark-paid that writes `paid_at` on the canonical row. UI intent,
 * checkout creation, button press, basket state, or "payment
 * started" flows are NOT authority and MUST NOT render "Paid".
 *
 * No UI, response, toast, notification, receipt, dashboard, or
 * booking/payment surface may claim "Paid" unless `paid_at` is
 * populated.
 *
 * The matching backend authority lives in:
 *   • `backend/canonical_state_language.py::PAYMENT_AUTHORITY`
 *   • `backend/payments.py::_fulfill_lesson_payment` (Stripe webhook)
 *   • `backend/lessons.py::mark_paid` (manual instructor settle)
 *
 * Doctrine pins:
 *   • `backend/tests/test_payments_truth_boundary_doctrine.py`
 */

/**
 * `true` if the row carries the authoritative `paid_at` timestamp.
 * Status enums (e.g. `payment_status === "paid"`) are NOT sufficient.
 */
export const isPaid = (item) => !!(item && item.paid_at);

/**
 * Maps a row to the badge key the PAYMENT_BADGE table understands.
 * Returns `"paid"` ONLY when `paid_at` is populated; otherwise falls
 * through to the `payment_status` enum (`unpaid`, `payment_due`,
 * `part_paid`, `credit_used`, …) so the row gets the correct
 * pre-settlement label.
 */
export const paymentBadgeKey = (item) => {
  if (!item) return null;
  if (isPaid(item)) return "paid";
  return item.payment_status || null;
};
